import { render, staticRenderFns } from "./UserSettingsSelect.vue?vue&type=template&id=45cafc18"
import script from "./UserSettingsSelect.vue?vue&type=script&lang=ts&scoped=true"
export * from "./UserSettingsSelect.vue?vue&type=script&lang=ts&scoped=true"
import style0 from "./UserSettingsSelect.vue?vue&type=style&index=0&id=45cafc18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports